<template>
  <iColumn
    width="fill"
    height="hug"
    gap="standard"
  >
    <template
      v-for="(block, blockIndex) in blocks"
      :key="blockIndex"
    >
      <iRow
        v-if="block.marker"
        width="fill"
        height="hug"
        gap="extraSmall"
        vertical-align="top"
      >
        <iText
          v-bind="fullTextOptionsAttributes"
          :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
          width="hug"
        >
          {{ block.marker }}
        </iText>
        <iRow
          width="fill"
          height="hug"
          gap="none"
          wrap="wrap"
          :min-width="0"
        >
          <iText
            v-for="(run, runIndex) in block.runs"
            :key="runIndex"
            v-bind="fullTextOptionsAttributes"
            :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
            width="hug"
            :font-weight="run.strong ? 'dark' : fullTextOptionsAttributes.fontWeight"
          >
            {{ runText(run) }}
          </iText>
        </iRow>
      </iRow>
      <iRow
        v-else
        width="fill"
        height="hug"
        gap="none"
        wrap="wrap"
        :min-width="0"
      >
        <iText
          v-for="(run, runIndex) in block.runs"
          :key="runIndex"
          v-bind="fullTextOptionsAttributes"
          :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
          width="hug"
          :font-weight="headingWeight(block) || (run.strong ? 'dark' : fullTextOptionsAttributes.fontWeight)"
          :font-size="headingSize(block) || fullTextOptionsAttributes.fontSize"
        >
          {{ runText(run) }}
        </iText>
      </iRow>
    </template>
  </iColumn>
</template>

<script>
import { camelToTitleCase } from "@bloglovin/vue-framework";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import { StaticBrandedTextElementMixin }
  from "%/dynamic-component-editor/standard-elements/text-element/static-branded-text-element-mixin";
import { markdownBlocks, BLOCK_HEADING }
  from "%/dynamic-component-editor/helpers/markdown-blocks";

const HEADING_SIZES = ["extraLarge", "large", "large", "standard", "standard", "standard"];

export default {
  name: "DynamicAppMarkdownElement",
  mixins: [DynamicElementMixin, DynamicElementWithContext, StaticBrandedTextElementMixin],
  elementPanelSettings: {
    displayName: "Prose",
    elementGroup: "general",
    displayIcon: "text",
    elementType: "element",
  },
  hidden: true,
  computed: {
    isEditable() {
      return false;
    },
    blocks() {
      const parsed = markdownBlocks(this.valueFromContext);
      if (parsed.length > 0) {
        return parsed;
      }
      if (this.editMode || this.isPreviewMode) {
        return markdownBlocks(this.placeholderText);
      }
      return [];
    },
    placeholderText() {
      if (this.exampleData) {
        return this.exampleData;
      }
      const field = this.elementContext?.field;
      return field ? camelToTitleCase(field) : this.$options.elementPanelSettings.displayName;
    },
  },
  methods: {
    headingWeight(block) {
      return block.type === BLOCK_HEADING ? "dark" : "";
    },
    runText(run) {
      return run.text.replace(/^ +| +$/g, spaces => "\u00a0".repeat(spaces.length));
    },
    headingSize(block) {
      if (block.type !== BLOCK_HEADING) {
        return "";
      }
      return HEADING_SIZES[block.level - 1];
    },
  },
};
</script>
